import { ArrowLeftRight, ChevronDown } from "lucide-react";
import { Link } from "react-router-dom";
import { useRef, useState } from "react";
import { resolveApiAssetUrl, type CompanyContext } from "@/shared/api/api-client";

import { useDismiss } from "@/shared/hooks/useDismiss";
export function CompanySwitcher({ company }: { company: CompanyContext }) {
  const [open, setOpen] = useState(false);
  const controlRef = useRef<HTMLDivElement>(null);

  useDismiss(open, () => setOpen(false), { ref: controlRef });

  return (
    <div className="company-switcher" ref={controlRef}>
      <button
        className="company-switcher-trigger"
        aria-label={`Empresa ativa: ${company.name}`}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen(current => !current)}
      >
        <span className={`company-switcher-badge ${company.logo_url ? "has-logo" : ""}`}>
          {company.logo_url
            ? <img src={resolveApiAssetUrl(company.logo_url)} alt=""/>
            : company.name.slice(0, 2).toUpperCase()}
        </span>
        <span className="company-switcher-name">{company.name}</span>
        <ChevronDown className="company-switcher-chevron" size={14}/>
      </button>
      {open && (
        <div className="company-switcher-menu" role="menu">
          <Link role="menuitem" to="/empresas" onClick={() => setOpen(false)}>
            <ArrowLeftRight size={16}/><span>Trocar empresa</span>
          </Link>
        </div>
      )}
    </div>
  );
}
